import compact from 'lodash/compact';
import map from 'lodash/fp/map';
import trim from 'lodash/trim';

/* global jQuery, window, document, once */
(($) => {
  once('scholarship.bef', document.body).forEach(() => {
    const syncLanguageLinks = () => {
      const languageBlock = document.querySelector('.block-language');
      if (languageBlock) {
        const links = languageBlock.querySelectorAll('a.language-link');
        const { search } = new URL(window.location.href);
        links.forEach((link) => {
          const linkUrl = new URL(link.href);
          linkUrl.search = search;
          link.setAttribute('href', linkUrl.toString());
        });
      }
    };
    $(window).ajaxComplete(syncLanguageLinks);

    // Submit form when dropdown filter is closed.
    const closeCollapse = () => {
      $('.views-exposed-form .close-list').on('click touch', (e) => {
        e.preventDefault();
        $(e.target).closest('form').find('input[type="submit"]').click();
      });
    };
    closeCollapse();
    $(window).ajaxComplete(closeCollapse);

    // Auto-submit when changing the sort order
    const submitSort = () => {
      $('.views-exposed-form .form-item-sort-by select').on('change', (e) => {
        $(e.target).closest('form').find('input[type="submit"]').click();
      });
    };
    submitSort();
    $(window).ajaxComplete(submitSort);

    // Update active filters
    const updateFilters = () => {
      const view = document.querySelector('.view-find-scholarships');
      if (!view) return;
      const filters = view.querySelector('.view-filters');
      const active = view.querySelector('.view-active-filters');
      const submit = view.querySelector('.form-actions [type="submit"]');
      active.innerHTML = '';
      let resetButtons = [];
      if (filters) {
        const generateCheckboxUnset = (checkbox) => {
          const label = filters.querySelector(`label[for="${checkbox.id}"]`);
          const textLabel = trim(label.innerHTML);
          const button = document.createElement('button');
          button.innerHTML = textLabel;
          button.classList.add('active-filter-btn');
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            label.click();
            submit.click();
          });
          return button;
        };

        // Keywords
        const keyword = filters.querySelector('[name="search_api_fulltext"][type="text"]');
        if (keyword && keyword.value) {
          const button = document.createElement('button');
          button.innerHTML = `"${keyword.value}"`;
          button.classList.add('active-filter-btn');
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            keyword.value = '';
            submit.click();
          });
          resetButtons.push(button);
        }

        // Checkboxes
        const checkboxes = filters.querySelectorAll('[type="checkbox"]:checked');
        resetButtons = [
          ...resetButtons,
          ...compact(map((checkbox) => generateCheckboxUnset(checkbox), checkboxes)),
        ];

        if (resetButtons.length > 0) {
          const div = document.createElement('div');
          div.innerHTML = 'Your Selections';
          active.appendChild(div);
        }
        map((button) => active.appendChild(button), resetButtons);
      }
    };

    updateFilters();
    $(window).ajaxComplete(updateFilters);
  });
})(jQuery);
